<template>
  <div class="w-full flex flex-col gap-y-4 bg-white">
    <div class="w-full bg-brand-gray-50">
      <Form
        :keep-values="true"
        :initial-values="{
          fromDate: now.toFormat('dd/MM/yyyy'),
          toDate: now.toFormat('dd/MM/yyyy')
        }"
        class="flex items-start gap-3 px-3 py-1"
        v-slot="{ values, resetForm }"
        @submit="(values) => onSubmit(values, resetForm)"
      >
        <Field
          :rules="requiredRule"
          name="fromDate"
          v-slot="{ field, errors: errs, handleChange, resetField }"
        >
          <DatepickerV2
            :field="field"
            :errors="errs"
            :label="$t('fromDate')"
            :default-value="field.value"
            input-class="ps-3 py-0.5"
            class="w-1/2"
            max-date="__now__"
            @on-change="
              (date) => {
                handleChange(date)
              }
            "
          >
          </DatepickerV2>
        </Field>
        <Field
          :rules="requiredRule"
          name="toDate"
          v-slot="{ field, errors: errs, handleChange, resetField }"
        >
          <DatepickerV2
            :disabled="!values.fromDate"
            :key="values.fromDate"
            :field="field"
            :errors="errs"
            :label="$t('toDate')"
            :default-value="field.value"
            :min-date="values.fromDate ?? '__now__'"
            max-date="__now__"
            input-class="ps-3 py-0.5"
            class="w-1/2"
            @on-change="(date) => handleChange(date)"
          >
          </DatepickerV2>
        </Field>
        <div class="size-24 flex justify-center items-center p-2 pb-2.5">
          <button
            class="text-center rounded-md bg-primary/80 pe-2 hover:bg-primary flex items-center gap-x-2 hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed text-white"
          >
            <div class="p-2 bg-primary rounded-s-md">
              <faMagnifyingGlass class="w-4 fill-white"></faMagnifyingGlass>
            </div>
            <span class="w-full text-center">
              {{ $t('Search') }}
            </span>
          </button>
        </div>
      </Form>
    </div>
    <div v-if="!isLoading && data.length === 0" class="w-full flex justify-center pb-3">
      {{ $t('NoRecordFound') }}
    </div>
    <div v-else class="px-3 pb-1.5">
      <AlertRow :data="item" :key="key" v-for="(item, key) in data" />
    </div>
  </div>
</template>

<script setup>
import faMagnifyingGlass from '@/assets/icons/faMagnifyingGlass.svg?component'
import DatepickerV2 from '@/components/SimpleForm/DatepickerV2.vue'
import axiosInstance from '@/services'
import AlertRow from '@/views/individual/dashboard/ServicesOverview/Alerts/AlertRow.vue'
import { DateTime } from 'luxon'
import { Field, Form } from 'vee-validate'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

const i18n = useI18n()
const isLoading = ref(true)
const showResponse = ref(false)
const data = ref([])

const now = DateTime.now()

function requiredRule(value) {
  if (!value || !`${value}`.trim()) {
    return i18n.t('INVALID_REQUIRED')
  }

  return true
}

async function onSubmit(form) {
  isLoading.value = true
  const body = {
    ...form,
    currentPage: 1,
    pageSize: 10,
    fromDate: DateTime.fromFormat(form.fromDate, 'dd/MM/yyyy').toFormat('yyyy/MM/dd'),
    toDate: DateTime.fromFormat(form.toDate, 'dd/MM/yyyy').toFormat('yyyy/MM/dd')
  }

  const response = await axiosInstance.post('/api/notification/uesr/alert', body)

  isLoading.value = false

  showResponse.value = response.collection.length > 0

  data.value = response.collection.map((c) => {
    const { templateTypeId } = c.notificationParameters
    return {
      ...c,
      selected: false,
      showAlert: templateTypeId == 279
    }
  })

  /**
   * TODO: parse response
   * web/client/shared/pages/notification/alert/userAlertCtrl.js
   */
}
</script>

<style lang="scss" scoped></style>
